// Toggle sub-tab in Pattern B mega-menu panel.
(function () {
  function initTabs(root) {
    var tabs = root.querySelectorAll('.cz-mega-panel-b__tab');
    var panels = root.querySelectorAll('.cz-mega-panel-b__grid');
    tabs.forEach(function (tab) {
      tab.addEventListener('mouseenter', function () { activate(tab); });
      tab.addEventListener('focus', function () { activate(tab); });
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        activate(tab);
      });
    });
    function activate(tab) {
      var targetId = tab.getAttribute('data-tab-target');
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.id === targetId;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
    }
  }
  function init() {
    document.querySelectorAll('.cz-mega-panel-b').forEach(initTabs);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
